import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const FilterOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="m18.95 4.6-3.13 4.08-2.65 3.45c-.32.42-.51.92-.53 1.45l-.2 4.19-1.37.95v-5.36c0-.56-.19-1.11-.52-1.55l-2.4-3.13L5.02 4.6h13.93Zm.26-1.6H4.76C3.54 3 2.85 4.4 3.59 5.36l3.29 4.29 2.4 3.13c.12.16.19.36.19.57v6.74c0 .53.42.9.86.9.16 0 .32-.05.47-.15l2.62-1.81c.36-.25.58-.66.6-1.1l.21-4.27c0-.2.08-.4.2-.56l2.65-3.45 3.29-4.29c.74-.97.05-2.36-1.17-2.36h.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default FilterOutlined
